const constants = {
        //"HOST": "http://localhost:4999",
        "HOST": "https://nxt.amplifino.com", 
}



export default constants